import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserProfile } from 'src/context/user-context/UserProvider';

import HomeIcon from 'src/icons/home';
import logoIcon from 'src/icons/logo.svg';
import logoutIcon from 'src/icons/logout.svg';
import MerchantIcon from 'src/icons/merchant';
import SettingsIcon from 'src/icons/settings';
import { LOCAL_STORAGE_TOKEN_KEY } from 'src/utils/constants';
import './Header.css';

const Header = () => {
    // Profile
    const { email, firstName, lastName } = useUserProfile();
    // Navigation
    const navigate = useNavigate();
    const location = useLocation();
    // State
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        if (location.pathname.startsWith('/merchant')) return setCurrentPage(1);
        if (location.pathname.startsWith('/settings')) return setCurrentPage(2);
        return setCurrentPage(0);
    }, [location]);

    const logout = () => {
        localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
        window.location.href = '/login';
    };

    return (
        <div className="header z-10 absolute w-screen px-2 md:px-10 py-4 border-b border-gray-light flex justify-between items-center">
            <div className="flex-1">
                <button
                    className={`navigation-button ${
                        currentPage === 0 ? 'selected' : ''
                    } p-2 bg-gray-light rounded-lg mr-4 relative`}
                    onClick={() => {
                        navigate('/', { replace: true });
                    }}
                >
                    <HomeIcon color={currentPage === 0 ? '#ffffff' : '#000000'} />
                </button>
                <button
                    className={`navigation-button ${
                        currentPage === 1 ? 'selected' : ''
                    } p-2 bg-gray-light rounded-lg mr-4 relative`}
                    onClick={() => {
                        navigate('/merchant', { replace: true });
                    }}
                >
                    <MerchantIcon color={currentPage === 1 ? '#ffffff' : '#000000'} />
                </button>
                <button
                    className={`navigation-button ${
                        currentPage === 2 ? 'selected' : ''
                    } p-2 bg-gray-light rounded-lg relative`}
                    onClick={() => {
                        navigate('/settings', { replace: true });
                    }}
                >
                    <SettingsIcon color={currentPage === 2 ? '#ffffff' : '#000000'} />
                </button>
            </div>
            <img src={logoIcon} alt="Payonix logo" className="hidden md:block w-10" width={40} />
            <div className="flex flex-1 justify-end">
                <div className="flex flex-col items-end">
                    {firstName && lastName && email && (
                        <>
                            <span>
                                {firstName} {lastName}
                            </span>
                            <span className="text-xs text-gray-darker">{email}</span>
                        </>
                    )}
                </div>
                <img src={logoutIcon} alt="log out" width={25} className="cursor-pointer ml-4" onClick={logout} />
            </div>
        </div>
    );
};

export default Header;
